import React, { useState, useEffect } from 'react';

export default function LiveTime(props) {
    const {
        value
    } = props;

    const [timeAgo, setTimeAgo] = useState('--');

    useEffect(() => {
        if (value) {
         const pastDate = new Date(value.replace(" ", "T") + "Z");
     
         const updateCounter = () => {
           const currentTime = new Date();
           const diffInMs = currentTime - pastDate;
     
           // Define time units in milliseconds
           const seconds = 1000;
           const minute = 60 * seconds;
           const hour = 60 * minute;
           const day = 24 * hour;
           const week = 7 * day;
           const month = 30 * day;
           const year = 365 * day;
     
           if (diffInMs < minute) {
             const secs = Math.floor(diffInMs / seconds);
             return secs === 1 ? "1s ago" : `${secs}s ago`;
           } else if (diffInMs < hour) {
             const mins = Math.floor(diffInMs / minute);
             const secs = Math.floor((diffInMs % minute) / seconds);
             return mins === 1
               ? `1 min ${secs}s ago`
               : `${mins} mins ${secs}s ago`;
           } else if (diffInMs < day) {
             const hrs = Math.floor(diffInMs / hour);
             const mins = Math.floor((diffInMs % hour) / minute);
             return hrs === 1
               ? `1 hr ${mins} mins ago`
               : `${hrs} hrs ${mins} mins ago`;
           } else if (diffInMs < week) {
             const days = Math.floor(diffInMs / day);
             const hrs = Math.floor((diffInMs % day) / hour);
             return days === 1
               ? `1 day ${hrs} hrs ago`
               : `${days} days ${hrs} hrs ago`;
           } else if (diffInMs < month) {
             const weeks = Math.floor(diffInMs / week);
             const days = Math.floor((diffInMs % week) / day);
             return weeks === 1
               ? `1 week ${days} days ago`
               : `${weeks} weeks ${days} days ago`;
           } else if (diffInMs < year) {
             const months = Math.floor(diffInMs / month);
             const weeks = Math.floor((diffInMs % month) / week);
             return months === 1
               ? `1 month ${weeks} weeks ago`
               : `${months} months ${weeks} weeks ago`;
           } else {
             const years = Math.floor(diffInMs / year);
             const months = Math.floor((diffInMs % year) / month);
             return years === 1
               ? `1 year ${months} months ago`
               : `${years} years ${months} months ago`;
           }
         };
     
         // Update the counter every second
         const intervalId = setInterval(() => {
           setTimeAgo(updateCounter());
         }, 1000); // Update every second
     
         // Cleanup interval on component unmount
         return () => clearInterval(intervalId);
        }
       }, [value])

    return (
        <div style={{ fontSize: '13px', color: 'rgb(42, 101, 0)', fontWeight: 'bold' }}>{timeAgo}</div>
    )
}